import React, { useState } from "react";
import { lessonCount, lessonsText } from "../../../utils/lessonCount";
import {
  Box,
  withStyles,
  Typography,
  createGenerateClassName,
  StylesProvider,
  createTheme,
  ThemeProvider,
  Button,
  Backdrop,
  Fade,
  Modal,
  Popper,
  List,
  ListItem,
  ListItemText,
  FormControl,
  IconButton,
  TextField,
  Menu,
  ClickAwayListener,
  InputLabel,
  MenuItem,
  Select,
  Checkbox,
  FormControlLabel,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
} from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import CloseIcon from "@material-ui/icons/Close";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  LESSON_DATE_TIME,
  PROPOSAL_TIME_OPTION_TYPES,
} from "../../../utils/constants";
import UserDefaultImage from "../../../assets/images/user-default.png";
import { showSuccessToast, toastAfterReload } from "../../../utils/successToast";
import avatarFor from "../../../utils/avatarFor";
import lessonsApi from "../../../apis/lessonsApi";
import lessonCategoriesApi from "../../../apis/lessonCategoriesApi";
import TimeSlotPicker from "../../TimeSlotPicker";
import CancelLessonModal from "../CancelLesson";
import StudentPanel from "./StudentPanel";
import { format, isValid, differenceInCalendarDays, startOfDay } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";

const generateClassName = createGenerateClassName({
  productionPrefix: "c",
  disableGlobal: true,
  seed: "create-lesson-modal",
});

const theme = createTheme({
  typography: {
    fontFamily: "'Nunito', 'Varela Round', sans-serif",
  },
  overrides: {
    MuiFormLabel: {
      root: {
        "&$focused": {
          color: "#333333",
        },
      },

    },
    MuiInput: {
      underline: {
        "&::after": {
          borderBottom: "2px solid #333333",
        },
      },
    },
  },
});

const SubmitProposalTimeButton = withStyles(() => ({
  root: {
    color: "#ffffff",
    backgroundColor: "#000000",
    "&:hover": {
      backgroundColor: "#000000",
    },
    height: 50,
    borderRadius: "140px",
    width: "100%",
  },
}))(Button);

const ProposeModal = withStyles((theme) => ({
  root: {
    backgroundColor: "#ffffff",
    padding: 32,
    borderRadius: 16,
    position: "relative",
    maxWidth: 500,
    maxHeight: "85%",
    margin: "auto",
    outline: 0,
    overflow: "auto",
    width: 500,
    [theme.breakpoints.down("sm")]: {
      margin: 0,
      padding: 16,
      maxWidth: "100%",
      width: "100%",
      maxHeight: "95%",
      marginTop: "auto",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
}))(Box);

const Close = withStyles(() => ({
  root: {
    position: "absolute",
    right: 12,
    top: 12,
    cursor: "pointer",
  },
}))(Box);

const ProposeInstructorInfo = withStyles(() => ({
  root: {
    fontSize: 18,
    lineHeight: "25px",
    fontWeight: 400,
    display: "flex",
    padding: "9px 0",
    alignItems: "center",
    "& > img": {
      width: 48,
      height: 48,
      borderRadius: "50%",
      marginRight: 14,
    },
  },
}))(Box);

const ProposeInstructorNameBox = withStyles(() => ({
  root: {},
}))(Box);

// The role is the label and the person is the value; at the same size and
// weight the eye had to read both to find out which was which.
const ProposeUserRole = withStyles(() => ({
  root: {
    fontSize: 13,
    fontWeight: 600,
    color: "#666666",
    lineHeight: "18px",
    margin: 0,
  },
}))(Typography);

const ProposeInstructorName = withStyles(() => ({
  root: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: "25px",
    margin: 0,
    display: "flex",
    alignItems: "center",
    gap: 2,
    cursor: "pointer",
    color: "#111827",
    borderRadius: 6,
    transition: "color 120ms ease",
    "&:hover": { color: "#000000" },
    // Nobody has been chosen yet: this is a prompt, not a name.
    "&[data-empty='true']": { color: "#6B7280", fontWeight: 500 },
  },
}))(Typography);

const ProposeModalInstructorList = withStyles(() => ({
  root: {
    backgroundColor: "#ffffff",
    border: "1px solid #E0E0E0",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.05)",
    borderRadius: 16,
    maxHeight: 300,
    overflowY: "auto",
    minWidth: 200,
  },
}))(Box);

const ProposalTimesPrimary = withStyles(() => ({
  root: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "20px",
    color: "#000000",
  },
}))(Typography);

const ProposalTimesBox = withStyles(() => ({
  root: {},
}))(Box);

const ProposalTime = withStyles((theme) => ({
  root: {
    padding: "12px 0",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
  },
}))(Box);











const TitleModal = withStyles(() => ({
  root: {
    fontSize: 20,
    fontWeight: 500,
    lineHeight: "28px",
    textTransform: "uppercase",
  },
}))(Typography);

const DatePickerTextField = withStyles((theme) => ({
  root: {
    maxWidth: "100%",
  },
}))(TextField);



const NotificationPopperTriangle = withStyles((theme) => ({
  root: {
    position: "absolute",
    top: "-7px",
    left: "50%",
    width: 12,
    height: 12,
    margin: "auto",
    transform: "translateX(-6px) rotate(45deg)",
    "-webkit-transform": "translateX(-6px) rotate(225deg)",
    "-moz-transform": "translateX(-6px) rotate(45deg)",
    "-o-transform": "translateX(-6px) rotate(45deg)",
    "-ms-transform": "translateX(-6px) rotate(45deg)",
    borderRight: "1px solid #E0E0E0",
    borderBottom: "1px solid #E0E0E0",
    backgroundColor: "#ffffff",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.05)",
    [theme.breakpoints.down("sm")]: {
      left: "59%",
    },
  },
}))(Box);

// Length and repeat used to live behind an unlabelled kebab, with the
// result shown as a bare blue icon. Nobody guesses what a floating ↻ means,
// so both are on the surface now, in words.
// Editing a weekly lesson used to look exactly like editing a one-off: the
// only way to learn it repeated was to press Save and be asked a question
// you were not expecting. This says so up front, and it is a statement, not
// a control — changing whether a lesson repeats is a different job.
const SeriesNote = withStyles(() => ({
  root: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "5px 11px",
    borderRadius: 999,
    backgroundColor: "#F3F4F6",
    color: "#4B5563",
    fontSize: 12.5,
    fontWeight: 600,
    marginTop: 12,
  },
}))(Box);

// The time being booked, first thing under the title.
const WhenBanner = withStyles(() => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    margin: "6px 0 10px",
    padding: "12px 16px",
    borderRadius: 12,
    backgroundColor: "#F6F7F9",
    fontFamily: "'Nunito', 'Varela Round', sans-serif",
    "& .day": { fontSize: 13.5, fontWeight: 600, color: "#666666" },
    "& .time": { fontSize: 22, fontWeight: 700, color: "#111827", lineHeight: 1.25, fontVariantNumeric: "tabular-nums" },
    "& .len": { fontSize: 15, fontWeight: 600, color: "#666666" },
    "& button": {
      flex: "0 0 auto",
      border: "1px solid #D1D5DB",
      background: "#ffffff",
      color: "#111827",
      borderRadius: 999,
      padding: "7px 16px",
      fontSize: 14,
      fontWeight: 600,
      fontFamily: "inherit",
      cursor: "pointer",
      transition: "transform 120ms ease, box-shadow 120ms ease",
    },
    "& button:hover": { boxShadow: "0 2px 6px rgba(17,24,39,0.10)" },
    "& button:active": { transform: "scale(0.97)" },
  },
}))(Box);

// Location and category on one line until someone wants to change them.
const MoreLine = withStyles(() => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
    margin: "4px 0 10px",
    fontSize: 14,
    color: "#374151",
    fontFamily: "'Nunito', 'Varela Round', sans-serif",
    "& .label": { color: "#666666" },
    "& .dot": { display: "inline-block", width: 8, height: 8, borderRadius: "50%", marginRight: 5 },
    "& button": {
      border: 0,
      background: "none",
      padding: 0,
      color: "#007BFF",
      fontWeight: 600,
      fontSize: 14,
      fontFamily: "inherit",
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
}))(Box);

// The list of times is full height now, so Save can sit below a long day.
// Pinning it means the owner never has to scroll to find the way out.
const SubmitDock = withStyles((theme) => ({
  root: {
    position: "sticky",
    bottom: -32,
    backgroundColor: "#ffffff",
    paddingTop: 14,
    paddingBottom: 32,
    marginTop: 18,
    zIndex: 1,
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      top: -18,
      height: 18,
      background: "linear-gradient(to top, #ffffff, rgba(255,255,255,0))",
      pointerEvents: "none",
    },
    [theme.breakpoints.down("sm")]: { bottom: -16, paddingBottom: 16 },
  },
}))(Box);

// What the chosen student has left, the moment they are chosen. Three
// states carry their own colour so the number reads before the words do:
// comfortable, running low, out. It informs; it never blocks the booking.
const BalanceLine = withStyles(() => ({
  root: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    marginTop: 4,
    fontSize: 12.5,
    fontWeight: 600,
    color: "#4B5563",
    fontVariantNumeric: "tabular-nums",
    "& .dot": { width: 7, height: 7, borderRadius: "50%", backgroundColor: "#9CA3AF", flex: "0 0 7px" },
    "&[data-tone='ok'] .dot": { backgroundColor: "#0E9F6E" },
    "&[data-tone='low'] .dot": { backgroundColor: "#F59E0B" },
    "&[data-tone='out'] .dot": { backgroundColor: "#DC2626" },
    "&[data-tone='out']": { color: "#B91C1C" },
    "& .muted": { fontWeight: 400, color: "#6B7280" },
  },
}))(Box);

const balanceTone = (balance) => {
  if (!balance || balance.bought === 0) return "none";
  if (balance.left <= 0) return "out";
  if (balance.left <= 2) return "low";
  return "ok";
};

const shortDate = (iso) => {
  if (!iso) return null;
  const d = new Date(`${iso}T12:00:00`);
  return isValid(d) ? format(d, "MMM d") : null;
};

const OptionSection = withStyles(() => ({
  root: {
    width: "100%",
    borderTop: "1px solid #EFF1F3",
    marginTop: 16,
    paddingTop: 16,
  },
}))(Box);

const OptionLabel = withStyles(() => ({
  root: {
    fontSize: 14,
    fontWeight: 600,
    color: "#4F4F4F",
    marginBottom: 8,
  },
}))(Typography);

const LengthGroup = withStyles(() => ({
  root: {
    display: "inline-flex",
    padding: 3,
    borderRadius: 999,
    backgroundColor: "#F1F2F4",
  },
}))(Box);

const LengthButton = withStyles(() => ({
  root: {
    border: "none",
    cursor: "pointer",
    borderRadius: 999,
    padding: "7px 16px",
    fontFamily: "'Nunito', 'Varela Round', sans-serif",
    color: "#6B7280",
    backgroundColor: "transparent",
    whiteSpace: "nowrap",
    textAlign: "center",
    lineHeight: 1.15,
    transition: "background-color 140ms ease, color 140ms ease, box-shadow 140ms ease",
    "& .len": { display: "block", fontSize: 13, fontWeight: 600 },
    // A longer slot spends more than one lesson: on credits, on the payroll
    // sheet, on Lessons Taught. Showing only the minutes hid the price.
    "& .cost": { display: "block", fontSize: 10.5, opacity: 0.72, marginTop: 1 },
    "&[data-active='true']": {
      backgroundColor: "#ffffff",
      color: "#111827",
      boxShadow: "0 1px 2px rgba(17,24,39,0.10), 0 1px 3px rgba(17,24,39,0.06)",
    },
    "&:focus-visible": { outline: "2px solid #111827", outlineOffset: 2 },
  },
}))(Box);

const RepeatRow = withStyles(() => ({
  root: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 16,
    marginTop: 14,
  },
}))(Box);

const RepeatNote = withStyles(() => ({
  root: {
    fontSize: 12.5,
    lineHeight: "17px",
    color: "#6B7280",
    marginTop: 3,
  },
}))(Typography);

// "2x" is a database value, not a length. Owners think in minutes.
const durationLabel = (units, minutes) => {
  const total = Math.round(units * (Number(minutes) || 45));
  const hours = Math.floor(total / 60);
  const rest = total % 60;
  if (hours === 0) return `${rest} min`;
  if (rest === 0) return `${hours} hr`;
  return `${hours} hr ${rest}`;
};

const ProposeInstructorInfoImg = withStyles((theme) => ({
  root: {
    height: 48,
    width: 48,
    flex: "0 0 48px",
    // `contain` letterboxed a portrait photo inside the circle and the
    // rounding then clipped the bands, which is why instructor avatars read
    // as chopped while the initials circles looked fine.
    backgroundImage: ({ backgroundimage }) => `url(${backgroundimage})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center top",
    position: "relative",
    borderRadius: "50%",
    marginRight: 14,
    boxShadow: "inset 0 0 0 1px rgba(17,24,39,0.08)",
  },
}))(Box);

const AddLessonModal = ({
  isOpen,
  onClose,
  instructors: instructorsProp,
  students: studentsProp,
  studio_id,
  date,
  isReload,
  addresses = [],
  studioName = "",
  // Preselects the student/lead when the modal opens from their own record
  // page, so "Schedule lesson" there means "with this person", not "go find
  // them again". Shape matches list entries: {id, attributes, studentType}.
  defaultStudent = null,
  // The studio's lesson length (Edit Studio setting); 1x/2x/3x multiply it.
  lessonMinutes = 45,
  // The studio's first slot (Edit Studio → Day starts at), minutes from midnight.
  dayStartMinutes,
  // The instructor column the slot was clicked in on the day sheet.
  defaultInstructorId = null,
  // Calendar page: refresh its events in place after booking instead of
  // the full reload isReload asks for.
  onCreated = null,
  // Edit mode. Present = this form is moving an existing lesson rather than
  // creating one, and it saves through PATCH instead of POST. Shape is the
  // calendar's own lesson attributes plus its id.
  lesson = null,
  // Times the chosen instructor is already teaching, so the slot strip can
  // grey them out. Optional: without it every slot reads as free.
  busyRanges = [],
  onUpdated = null,
}) => {
  const isEdit = Boolean(lesson && lesson.id);

  // Where focus was when the form opened: the lesson or the time slot that
  // was clicked. MUI hands it back on close with a plain focus(), and Chrome
  // scrolls a lesson that is not wholly in view to the middle of the page,
  // so the sheet jumped each time the form closed (Stefan, call 8). Read
  // here, not in an effect: by the time effects run the form has the focus.
  const openedFrom = React.useRef(null);
  if (isOpen && !openedFrom.current && typeof document !== "undefined") {
    openedFrom.current = document.activeElement;
  }
  React.useEffect(() => {
    if (!isOpen) return undefined;
    return () => {
      const el = openedFrom.current;
      openedFrom.current = null;
      if (el && el !== document.body && el.focus && document.contains(el)) {
        try {
          el.focus({ preventScroll: true });
        } catch (e) {
          // an element that cannot take focus any more
        }
      }
    };
  }, [isOpen]);
  const current_user = window.current_user || {};
  const { id } = current_user;
  // Cancelling from the sheet, so the day being looked at stays put. A past
  // lesson is the owner's call (it gives the student a lesson back).
  const [cancelOpen, setCancelOpen] = useState(false);
  const canCancel = isEdit && (lesson.status === "scheduled" || (lesson.status === "completed" && current_user.role === "owner"));

  // Deduplicate instructors and students by ID
  const instructors = React.useMemo(() => {
    if (!Array.isArray(instructorsProp)) return [];
    const seen = new Set();
    return instructorsProp.filter(instructor => {
      if (seen.has(instructor.id)) return false;
      seen.add(instructor.id);
      return true;
    });
  }, [instructorsProp]);

  const students = React.useMemo(() => {
    if (!Array.isArray(studentsProp)) return [];
    const seen = new Set();
    return studentsProp.filter(student => {
      if (seen.has(student.id)) return false;
      seen.add(student.id);
      return true;
    });
  }, [studentsProp]);

  // 1x / 2x / 3x, read back off a lesson that already has a length; 1.5x
  // too where the studio counts half lessons.
  const halves = !!current_user.studio_lesson_halves;
  const lengthOptions = halves ? ["1x", "1.5x", "2x", "3x"] : ["1x", "2x", "3x"];
  const unitsFromLesson = () => {
    if (!isEdit || !lesson.start_time || !lesson.end_time) return 1;
    const minutes = (new Date(lesson.end_time) - new Date(lesson.start_time)) / 60000;
    const ratio = minutes / (lessonMinutes || 45);
    const units = halves ? Math.round(ratio * 2) / 2 : Math.round(ratio);
    return Math.min(Math.max(units || 1, 1), 3);
  };

  const studentFromLesson = () => {
    if (!isEdit) return defaultStudent || {};
    // A contact with a login is listed by the login, so a lesson booked on
    // the contact is found through it.
    const wanted = [lesson.lead_id || lesson.student_id, lesson.lead_login_id].filter(Boolean);
    for (const id of wanted) {
      const found = studentsProp.find((entry) => String(entry.id) === String(id));
      if (found) return found;
    }
    return {};
  };

  const [errorMessage, setErrorMessage] = useState();

  const [currentStudent, setCurrentStudent] = useState(studentFromLesson);
  // Who the lesson is booked for now, whatever the form has been changed to:
  // the card link opens their card.
  const savedStudent = React.useMemo(() => (isEdit ? studentFromLesson() : {}), [isEdit, lesson && lesson.id, studentsProp]);
  // Couples & coaching: extra participants on the same slot.
  const [partnerIds, setPartnerIds] = useState([]);
  const [coachId, setCoachId] = useState("");
  const [currentInstructor, setCurrentInstructor] = useState(() => {
    if (!Array.isArray(instructors) || instructors.length === 0) return {};
    const wanted = isEdit ? lesson.instructor_id : defaultInstructorId;
    const chosen = wanted
      ? instructors.find((i) => String(i.id) === String(wanted))
      : null;
    return chosen || instructors[0];
  });
  const [isOpenStudentListPopper, setIsOpenStudentListPopper] = useState(false);
  const [studentListPopperEl, setStudentListPopperEl] = useState(null);
  const [isOpenInstructorListPopper, setIsOpenInstructorListPopper] =
    useState(false);
  const [instructorListPopperEl, setInstructorListPopperEl] = useState(null);
  const [proposalTimesOut, setProposalTimesOut] = useState([
    {
      id: 1,
      date_time: isEdit && lesson.start_time ? new Date(lesson.start_time) : date || null,
      options: [`${unitsFromLesson()}x`],
    },
  ]);
  const [currentProposalTime, setCurrentProposalTime] = useState();
  // Opened from a clicked slot or on a booked lesson, the time is already
  // decided, so it heads the form and the picker waits behind Change. Stefan
  // booked 9:00 by mistake because the 5:15 he clicked sat below the fold
  // (call 9: "if you click at 515, it should just be here"). Change swaps the
  // summary for the picker and pressing a time swaps it back, so Submit stays
  // the form's only finish (Drago, Oct 29: a "Done" beside Submit read as two).
  const [whenOpen, setWhenOpen] = useState(() => !(isEdit ? lesson.start_time : date));
  // Location and category hold the studio's defaults on almost every
  // booking: one line says what they are and opens them on request.
  const [moreOpen, setMoreOpen] = useState(false);
  const [addressId, setAddressId] = useState(() => {
    if (isEdit && lesson.studio_address_id) return lesson.studio_address_id;
    return Array.isArray(addresses) && addresses.length > 0 ? addresses[0].id : "";
  });
  // The lesson category (FirstClass's card) this lesson counts against.
  // Offered only when the studio has more than one; otherwise every lesson
  // is filed in the one there is.
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState(isEdit ? lesson.lesson_category_id || "" : "");
  React.useEffect(() => {
    if (!isOpen) return undefined;
    let cancelled = false;
    lessonCategoriesApi.list().then((res) => {
      // Showcase and Trips hold money, not lessons: never a lesson's category.
      if (!cancelled && !res.errors) setCategories((res.categories || []).filter((c) => c.holds_lessons !== false));
    });
    return () => {
      cancelled = true;
    };
  }, [isOpen]);
  // An opt-in category (Indiana) is offered only to the people ticked for
  // it, plus whatever this lesson is already filed in.
  const ticked = (c) => {
    if (!c.opt_in) return true;
    if (isEdit && lesson.lesson_category_id === c.id) return true;
    if (!currentStudent || !currentStudent.id) return false;
    const people = c.people || {};
    return currentStudent.studentType === "lead"
      ? (people.lead_ids || []).includes(currentStudent.id)
      : (people.user_ids || []).includes(currentStudent.id);
  };
  const offeredCategories = categories.filter(ticked);
  const chosenCategoryId = (offeredCategories.some((c) => c.id === categoryId) ? categoryId : null) || offeredCategories[0]?.id || null;
  const chosenCategory = offeredCategories.find((c) => c.id === chosenCategoryId) || null;
  // One address has nothing to choose; neither has one category.
  const hasPlaces = Array.isArray(addresses) && addresses.length > 1;
  const hasCategories = offeredCategories.length > 1;
  const placeName = (() => {
    const place = (addresses || []).find((a) => String(a.id) === String(addressId));
    const at = (place && place.attributes) || {};
    return at.city || at.street || "";
  })();

  // How many later instances "this and all following" would move. Fetched
  // when the dialog opens: zero means there is no question worth asking.
  const [followingCount, setFollowingCount] = useState(0);
  // The scope the owner picked, carried through the class-conflict and
  // overlap dialogs so a confirmation does not silently fall back to "this".
  const [scopeDialogOpen, setScopeDialogOpen] = useState(false);
  const [pendingScope, setPendingScope] = useState("this");
  const [touched, setTouched] = useState(false);
  // { taught: { instructor_id: [person ids] }, assigned: { instructor_id:
  // [lead ids] }, teachers_of: { lead_id: [instructor ids] } }, so the
  // student list leads with this teacher's own students (assigned first,
  // then everyone they have taught), and the instructor list opens on the
  // student's own teachers (Stefan, call 6, 1:18).
  const [taughtByInstructor, setTaughtByInstructor] = useState({});
  const [assignedByInstructor, setAssignedByInstructor] = useState({});
  // Where each person usually dances, for the student panel's columns.
  const [places, setPlaces] = useState({});
  const modalRef = React.useRef(null);
  const [teachersOf, setTeachersOf] = useState({});
  const instructorPicked = React.useRef(false);
  // {bought, taken, booked, left, runs_out_on} for the chosen student.
  const [balance, setBalance] = useState(null);
  const [datePickerErrorMessage, setDatePickerErrorMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);
  // conflicts: studio classes found by the preflight. overlap: the server's
  // 409 message when the student or instructor already has a lesson then.
  const [conflictDialog, setConflictDialog] = useState({ open: false, conflicts: [], overlap: null });
  // A lesson on an earlier day counts as taken the moment it is saved and
  // nobody is told, so it is worth one look. FirstClass asks the same
  // (Stefan, call 6, 1:45). Logging this afternoon's lesson at the end of
  // the day is routine and is not asked about.
  const [pastPrompt, setPastPrompt] = useState(null);
  const pastConfirmed = React.useRef(false);
  const earlierDayThan = (when) => isValid(when) && startOfDay(when) < startOfDay(new Date());
  const needsPastConfirm = () => {
    if (pastConfirmed.current) return false;
    const first = proposalTimesOut[0]?.date_time;
    if (!earlierDayThan(first)) return false;
    // Editing a lesson that was already on a past day: no news there.
    if (isEdit && lesson.start_time && earlierDayThan(new Date(lesson.start_time))) return false;
    setPastPrompt({ when: first, submit: isEdit ? "edit" : "create" });
    return true;
  };
  // Once someone has been chosen for the slot, a stray click outside the
  // form must not throw the booking away. The X and Escape still close it.
  const isDirty = isEdit
    ? touched
    : (Boolean(currentStudent && currentStudent.id) && !defaultStudent) ||
      partnerIds.length > 0 ||
      Boolean(coachId);
  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // People the chosen instructor has taught come first, in the order they
  // already had; nobody is hidden, so the search box still finds the whole
  // roster. With no instructor chosen the list is exactly as it was.
  const orderedStudents = React.useMemo(() => {
    const assigned = (currentInstructor.id && assignedByInstructor[currentInstructor.id]) || [];
    const rank = new Map(assigned.map((id, i) => [id, i]));
    const taught = new Set(
      (currentInstructor.id && taughtByInstructor[currentInstructor.id]) || []
    );
    const tagged = students.map((student) => ({
      ...student,
      assignedToCurrent: rank.has(student.id),
      taughtByCurrent: rank.has(student.id) || taught.has(student.id),
    }));
    if (taught.size === 0 && rank.size === 0) return tagged;
    return [
      ...tagged.filter((student) => student.assignedToCurrent).sort((a, b) => rank.get(a.id) - rank.get(b.id)),
      ...tagged.filter((student) => !student.assignedToCurrent && student.taughtByCurrent),
      ...tagged.filter((student) => !student.taughtByCurrent),
    ];
  }, [students, taughtByInstructor, assignedByInstructor, currentInstructor.id]);

  // The student's own teachers first, the main one on top.
  const studentTeacherIds = (currentStudent && currentStudent.id && teachersOf[currentStudent.id]) || [];
  const orderedInstructors = React.useMemo(() => {
    if (!studentTeacherIds.length) return instructors;
    const rank = new Map(studentTeacherIds.map((id, i) => [String(id), i]));
    return [
      ...instructors.filter((i) => rank.has(String(i.id))).sort((a, b) => rank.get(String(a.id)) - rank.get(String(b.id))),
      ...instructors.filter((i) => !rank.has(String(i.id))),
    ];
  }, [instructors, studentTeacherIds.join(",")]);

  // Opened from a student's record with no column clicked: start on their
  // main teacher, unless someone has already picked.
  React.useEffect(() => {
    if (isEdit || defaultInstructorId || instructorPicked.current || !studentTeacherIds.length) return;
    const main = instructors.find((i) => String(i.id) === String(studentTeacherIds[0]));
    if (main && main.id !== currentInstructor.id) setCurrentInstructor(main);
  }, [studentTeacherIds.join(",")]);

  React.useEffect(() => {
    if (!isOpen) return;
    let cancelled = false;
    lessonsApi.taughtStudents().then((res) => {
      if (cancelled) return;
      const body = res || {};
      // Older servers answered with the bare { instructor: [ids] } map.
      const shaped = body.taught || body.assigned || body.teachers_of;
      setTaughtByInstructor(shaped ? body.taught || {} : body);
      setAssignedByInstructor(shaped ? body.assigned || {} : {});
      setTeachersOf(shaped ? body.teachers_of || {} : {});
      setPlaces(body.places || {});
    });
    return () => {
      cancelled = true;
    };
  }, [isOpen]);

  // Fetched per person, on choice, not for the whole roster up front: one
  // small request, and only when there is somebody to ask about.
  React.useEffect(() => {
    if (!isOpen || !currentStudent || !currentStudent.id) {
      setBalance(null);
      return undefined;
    }
    let cancelled = false;
    const isLead = currentStudent.studentType === "lead";
    lessonsApi
      .balance(isLead ? { leadId: currentStudent.id } : { studentId: currentStudent.id })
      .then((b) => {
        if (cancelled) return;
        setBalance(b && typeof b.left === "number" ? b : null);
      });
    return () => {
      cancelled = true;
    };
  }, [isOpen, currentStudent && currentStudent.id]);

  // A weekly lesson is stored as a chain, so only the server knows how long
  // the tail is. Failing quietly is right: worst case the dialog does not
  // offer the series question and the edit lands on this lesson alone.
  React.useEffect(() => {
    if (!isEdit || !isOpen) return;
    let cancelled = false;
    lessonsApi
      .getEditContext(lesson.id)
      .then((payload) => {
        if (cancelled) return;
        setFollowingCount(Number(payload?.meta?.series?.following_count) || 0);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [isEdit, isOpen, lesson && lesson.id]);

  const onOpenStudentListPopper = (event) => {
    setStudentListPopperEl(event.currentTarget);
    setIsOpenStudentListPopper(!isOpenStudentListPopper);
  };


  const onOpenInstructorListPopper = (event) => {
    setInstructorListPopperEl(event.currentTarget);
    setIsOpenInstructorListPopper(!isOpenInstructorListPopper);
  };

  const onCloseInstructorListPopper = (event) => {
    setInstructorListPopperEl(null);
    setIsOpenInstructorListPopper(false);
  };

  // The instructor list always closed on a click outside; the student list
  // only closed from its own button, so a click anywhere else left it
  // hanging over the form (Stefan, call 3, 29:30: "this does for that one,
  // but not the other one").
  const onCloseStudentListPopper = () => {
    setStudentListPopperEl(null);
    setIsOpenStudentListPopper(false);
  };

  const onClickStudentPopper = (stu) => {
    setErrorMessage();
    setTouched(true);
    setStudentListPopperEl(null);
    setIsOpenStudentListPopper(!isOpenStudentListPopper);
    if (currentStudent.id !== stu.id) {
      setCurrentStudent(stu);
      // Partner selection belongs to the previous student — clear it.
      setPartnerIds([]);

      // Where they last danced, if it is one of this studio's rooms. The
      // lookup is not scoped to the studio, and a booking now carries its
      // location, so a room from somewhere else would be refused.
      const { last_studio_address_id } = stu.attributes;
      if (last_studio_address_id && (addresses || []).some((a) => a.id === last_studio_address_id)) {
        setAddressId(last_studio_address_id);
      }
    }
  };

  const onClickInstructorPopper = (ins) => {
    instructorPicked.current = true;
    setErrorMessage();
    setTouched(true);
    setInstructorListPopperEl(null);
    setIsOpenInstructorListPopper(!isOpenInstructorListPopper);
    if (currentInstructor.id !== ins.id) {
      setCurrentInstructor(ins);
    }
  };

  const onChangeProposalDateTime = (event, id) => {
    setTouched(true);
    setProposalTimesOut(
      proposalTimesOut.map((item) => {
        if (item.id === id) {
          return {
            id: item.id,
            date_time: event,
            options: item.options,
          };
        }
        return item;
      })
    );
  };


  // Length is a choice of one, repeat is a switch. The old handler treated
  // both as toggles, so clicking the length you already had removed it and
  // left the lesson with no length at all.
  const onChangeProposalTimeOption = (option, forTime = null) => {
    const target = forTime || currentProposalTime;
    if (!target) return;
    const isRecurring = option === PROPOSAL_TIME_OPTION_TYPES.RECURRING;
    setTouched(true);
    setProposalTimesOut(
      proposalTimesOut.map((item) => {
        if (item.id !== target.id) return item;

        if (isRecurring) {
          const on = item.options.includes(option);
          return {
            ...item,
            options: on
              ? item.options.filter((o) => o !== option)
              : [...item.options, option],
          };
        }

        const lengths = [
          PROPOSAL_TIME_OPTION_TYPES["1X"],
          PROPOSAL_TIME_OPTION_TYPES["1.5X"],
          PROPOSAL_TIME_OPTION_TYPES["2X"],
          PROPOSAL_TIME_OPTION_TYPES["3X"],
        ];
        return {
          ...item,
          options: [...item.options.filter((o) => !lengths.includes(o)), option],
        };
      })
    );
  };

  const buildLessonPayload = ({ confirmOverlap = false } = {}) => {
    const isLead = currentStudent.studentType === 'lead';
    return {
      lesson: {
        ...(confirmOverlap ? { confirm_overlap: true } : {}),
        ...(isLead ? { lead_id: currentStudent.id } : { student_id: currentStudent.id }),
        instructor_id: currentInstructor.id,
        // The Location picker's choice. Leaving it out filed every new
        // booking at the studio's first address, whatever the form showed.
        studio_address_id: addressId,
        ...(categories.length > 1 ? { lesson_category_id: chosenCategoryId } : {}),
        ...(partnerIds.length > 0 ? { additional_lead_ids: partnerIds } : {}),
        ...(coachId ? { additional_instructor_ids: [coachId] } : {}),
        studio_id: studio_id,
        out: proposalTimesOut.map((item) => ({
          ...item,
          date_time: zonedTimeToUtc(item.date_time, clientTimeZone).toISOString(),
        })),
      },
    };
  };

  const performCreate = async ({ confirmOverlap = false } = {}) => {
    try {
      setIsLoading(true);
      await lessonsApi.create(buildLessonPayload({ confirmOverlap }));
      setIsLoading(false);

      // State the fact, skip the ceremony: close, toast, and refresh the
      // page data. The toast survives the reload via sessionStorage.
      const first = proposalTimesOut[0]?.date_time;
      const when = first && isValid(first) ? format(first, "EEE h:mm a") : null;
      const who = currentStudent.attributes?.first_name || null;
      const count = proposalTimesOut.length;
      let message = count > 1
        ? `${count} lessons scheduled${who ? ` with ${who}` : ""}`
        : `Lesson scheduled${when ? ` · ${when}` : ""}${who ? ` with ${who}` : ""}`;

      onClose();
      if (onCreated) {
        showSuccessToast(message);
        onCreated();
      } else if (isReload) {
        toastAfterReload(message);
        window.location.reload();
      } else {
        showSuccessToast(message);
      }
    } catch (error) {
      setIsLoading(false);
      // Someone is already booked then. Say who, and let the owner decide.
      if (error && typeof error === 'object' && error.overlap) {
        setConflictDialog({ open: true, conflicts: [], overlap: error.errors || 'Already booked at that time.' });
        return;
      }
      const errorMessage =
        typeof error === 'string' ? error :
        error?.errors && typeof error.errors === 'string' ? error.errors :
        error?.data ? error.data :
        error?.message ? error.message :
        'An error occurred';
      setErrorMessage(errorMessage);
    }
  };

  const unitsForSubmit = () => {
    const picked = (proposalTimesOut[0]?.options || []).find((o) => /^\d+(\.\d)?x$/i.test(o));
    return parseFloat(picked) || 1;
  };

  // The reschedule counterpart of performCreate. scope is what the owner
  // answered to the series question; "this" is right for a one-off lesson
  // and is what an unanswered question falls back to.
  const performUpdate = async ({ confirmOverlap = false, scope = "this" } = {}) => {
    try {
      setIsLoading(true);
      const isLead = currentStudent.studentType === "lead";
      const when = proposalTimesOut[0]?.date_time;
      const payload = {
        lesson: {
          scope,
          ...(confirmOverlap ? { confirm_overlap: true } : {}),
          ...(isLead
            ? { lead_id: currentStudent.id, student_id: "" }
            : { student_id: currentStudent.id, lead_id: "" }),
          instructor_id: currentInstructor.id,
          studio_address_id: addressId,
          start_time: zonedTimeToUtc(when, clientTimeZone).toISOString(),
          duration_units: unitsForSubmit(),
        },
      };
      const response = await lessonsApi.update(lesson.id, payload);
      // The category is a fact about the lesson, not its time, so it rides
      // the content update rather than the reschedule.
      if (categories.length > 1 && chosenCategoryId !== (lesson.lesson_category_id || categories[0]?.id)) {
        await lessonsApi.update(lesson.id, { lesson: { lesson_category_id: chosenCategoryId } });
      }
      setIsLoading(false);

      const moved = Number(response?.lessons_moved) || 1;
      const label = when && isValid(when) ? format(when, "EEE h:mm a") : null;
      const message =
        moved > 1
          ? `${moved} lessons moved${label ? ` · from ${label}` : ""}`
          : `Lesson moved${label ? ` · ${label}` : ""}`;

      onClose();
      if (onUpdated) {
        showSuccessToast(message);
        onUpdated();
      } else {
        toastAfterReload(message);
        window.location.reload();
      }
    } catch (error) {
      setIsLoading(false);
      if (error && typeof error === "object" && error.overlap) {
        setConflictDialog({
          open: true,
          conflicts: [],
          overlap: error.errors || "Already booked at that time.",
        });
        return;
      }
      setErrorMessage(
        typeof error === "string"
          ? error
          : error?.errors && typeof error.errors === "string"
          ? error.errors
          : error?.data
          ? error.data
          : error?.message
          ? error.message
          : "An error occurred"
      );
    }
  };

  // Everything both paths have to agree on before anything is sent.
  const formIsUsable = () => {
    if (!currentStudent.id || !currentInstructor.id) {
      const missing = [
        !currentStudent.id && "a student",
        !currentInstructor.id && "an instructor",
      ].filter(Boolean);
      setErrorMessage(`Please select ${missing.join(" and ")}`);
      return false;
    }
    if (proposalTimesOut.some((item) => !isValid(item.date_time))) {
      setDatePickerErrorMessage("Invalid date, please try again");
      return false;
    }
    setDatePickerErrorMessage();
    return true;
  };

  // The studio-class preflight, shared by booking and rescheduling.
  const classConflictsFound = async () => {
    try {
      const proposals = proposalTimesOut.map((item) => ({
        date_time: zonedTimeToUtc(item.date_time, clientTimeZone).toISOString(),
        duration: unitsForSubmit() * lessonMinutes,
      }));
      const { studio_class_conflicts: conflicts = [] } =
        await lessonsApi.checkStudioClassConflicts({
          instructor_id: currentInstructor.id,
          studio_address_id: addressId,
          proposals,
        });
      if (conflicts.length > 0) {
        setConflictDialog({ open: true, conflicts });
        return true;
      }
    } catch (e) {
      // If the preflight itself fails, fall through and let the save decide.
    }
    return false;
  };

  const onSubmitEditLesson = async () => {
    if (!formIsUsable()) return;
    if (needsPastConfirm()) return;
    // Google Calendar's question, and only when it has an answer that
    // matters: with nothing after this lesson, both choices are the same.
    if (followingCount > 0) {
      setScopeDialogOpen(true);
      return;
    }
    if (await classConflictsFound()) return;
    performUpdate({ scope: "this" });
  };

  const onChooseScope = async (scope) => {
    setScopeDialogOpen(false);
    setPendingScope(scope);
    if (await classConflictsFound()) return;
    performUpdate({ scope });
  };

  const onSubmitCreateLesson = async () => {
    if (!currentStudent.id || !currentInstructor.id) {
      const missing = [!currentStudent.id && "a student", !currentInstructor.id && "an instructor"].filter(Boolean);
      setErrorMessage(`Please select ${missing.join(" and ")}`);
      return;
    }
    const proposalTimesOutInvalidDate = proposalTimesOut.filter((item) => isValid(item.date_time));
    if (proposalTimesOut.length > proposalTimesOutInvalidDate.length) {
      setDatePickerErrorMessage("Invalid date, please try again");
      return;
    } else {
      setDatePickerErrorMessage();
    }
    if (needsPastConfirm()) return;

    try {
      const proposals = proposalTimesOut.map((item) => {
        const minutes = ((item.options || []).join("").match(/(\d+)x/i) || [])[1];
        const duration = (parseInt(minutes, 10) || 1) * lessonMinutes;
        return {
          date_time: zonedTimeToUtc(item.date_time, clientTimeZone).toISOString(),
          duration,
        };
      });
      const { studio_class_conflicts: conflicts = [] } = await lessonsApi.checkStudioClassConflicts({
        instructor_id: currentInstructor.id,
        studio_address_id: addressId,
        proposals,
      });
      if (conflicts.length > 0) {
        setConflictDialog({ open: true, conflicts });
        return;
      }
    } catch (e) {
      // If preflight fails, fall through and create anyway
    }

    performCreate();
  };

  const confirmConflictAndCreate = () => {
    const confirmOverlap = Boolean(conflictDialog.overlap);
    setConflictDialog({ open: false, conflicts: [], overlap: null });
    if (isEdit) {
      performUpdate({ confirmOverlap, scope: pendingScope });
      return;
    }
    performCreate({ confirmOverlap });
  };

  const cancelConflictDialog = () => {
    setConflictDialog({ open: false, conflicts: [], overlap: null });
  };


  const onSelectAddress = (event) => {
    setTouched(true);
    setAddressId(event.target.value);
  };

  return (
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider theme={theme}>
        {isOpen && (
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={isOpen}
              onClose={(event, reason) => {
                if (reason === "backdropClick" && isDirty) return;
                onClose();
                setIsOpenInstructorListPopper(false);
                setIsOpenStudentListPopper(false);
              }}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
              disableEnforceFocus
              // Focus goes back without moving the page (see openedFrom).
              disableRestoreFocus
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Fade in={isOpen}>
                <ProposeModal ref={modalRef}>
                    <>
                      <Close onClick={onClose}>
                        <CloseIcon />
                      </Close>
                      <TitleModal>{isEdit ? "Edit lesson" : "Schedule lesson"}</TitleModal>
                      {students.length === 0 && !isEdit ? (
                        <Box style={{ padding: "20px 0 8px" }}>
                          <Typography
                            style={{
                              fontSize: 15,
                              lineHeight: "22px",
                              color: "#4A4A4A",
                              marginBottom: 24,
                            }}
                          >
                            You don't have any students yet. Add a student or
                            lead first, then come back to schedule their lesson.
                          </Typography>
                          <SubmitProposalTimeButton
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              window.location.href = "/leads";
                            }}
                          >
                            Add a student or contact
                          </SubmitProposalTimeButton>
                          <Typography
                            style={{
                              fontSize: 13,
                              color: "#666666",
                              marginTop: 16,
                            }}
                          >
                            New to this?{" "}
                            <a
                              href="/help?faq=lead-vs-student"
                              style={{ color: "#007BFF", fontWeight: 600 }}
                            >
                              Contact vs. student, what's the difference?
                            </a>
                          </Typography>
                        </Box>
                      ) : (
                        <>
                      {(() => {
                        if (proposalTimesOut.length !== 1) return null;
                        const proposalTime = proposalTimesOut[0];
                        const when = proposalTime.date_time;
                        if (whenOpen || !when || !isValid(when)) {
                          return (
                            <Box className="juice-in" data-testid="when-picker" style={{ margin: "6px 0 10px" }}>
                              <OptionLabel style={{ marginBottom: 10 }}>When</OptionLabel>
                              <TimeSlotPicker
                                value={when}
                                onChange={(next) => onChangeProposalDateTime(next, proposalTime.id)}
                                onSlotPicked={() => setWhenOpen(false)}
                                lessonMinutes={lessonMinutes}
                                dayStartMinutes={dayStartMinutes}
                                durationUnits={unitsForSubmit()}
                                busyRanges={busyRanges}
                              />
                            </Box>
                          );
                        }
                        return (
                          <WhenBanner data-testid="when-banner" className="juice-in">
                            <Box style={{ minWidth: 0 }}>
                              <div className="day">{format(when, "EEEE, MMMM d")}</div>
                              <div className="time">
                                {format(when, "h:mm a")}
                                <span className="len"> · {durationLabel(unitsForSubmit(), lessonMinutes)}</span>
                              </div>
                            </Box>
                            <button
                              type="button"
                              data-testid="when-change"
                              aria-label="Change the time"
                              onClick={() => setWhenOpen(true)}
                            >
                              Change
                            </button>
                          </WhenBanner>
                        );
                      })()}
                      {/* A new booking needs no intro: the form says who,
                          when and how often itself. */}
                      {isEdit && (
                        <Typography
                          style={{
                            fontSize: 14,
                            lineHeight: "20px",
                            color: "#666666",
                            marginTop: 4,
                            marginBottom: 16,
                          }}
                        >
                          <>
                            Change the time, the length, the instructor, the
                            student or the location. Everyone on the lesson is
                            told.{" "}
                            {/* The student's card is one click from the sheet,
                                not three (Stefan, call 9: FirstClass opens it
                                from the bottom of a block). */}
                            <Typography
                              component="a"
                              href={`/lessons/${lesson.id}/contact`}
                              data-testid="edit-lesson-card"
                              style={{
                                color: "#007BFF",
                                fontWeight: 600,
                                textDecoration: "underline",
                                fontSize: 14,
                              }}
                            >
                              {savedStudent?.attributes?.first_name
                                ? `Open ${savedStudent.attributes.first_name}'s card`
                                : "Open their card"}
                            </Typography>
                            {" · "}
                            {/* Clicking a lesson used to open its page. Notes
                                and videos still live there, so keep the door. */}
                            <Typography
                              component="a"
                              href={`/lessons/${lesson.id}`}
                              style={{
                                color: "#007BFF",
                                fontWeight: 600,
                                textDecoration: "underline",
                                fontSize: 14,
                              }}
                            >
                              Open the lesson page
                            </Typography>
                            {canCancel && (
                              <>
                                {" · "}
                                <Typography
                                  component="button"
                                  type="button"
                                  data-testid="edit-lesson-cancel"
                                  onClick={() => setCancelOpen(true)}
                                  style={{
                                    color: "#B91C1C",
                                    fontWeight: 600,
                                    textDecoration: "underline",
                                    fontSize: 14,
                                    background: "none",
                                    border: 0,
                                    padding: 0,
                                    cursor: "pointer",
                                    fontFamily: "inherit",
                                  }}
                                >
                                  Cancel this lesson
                                </Typography>
                              </>
                            )}
                          </>
                        </Typography>
                      )}
                      {isEdit && lesson.recurring && (
                        <SeriesNote>
                          <span aria-hidden="true">&#8635;</span>
                          {followingCount > 0
                            ? `Repeats weekly · ${followingCount} more after this one`
                            : "Repeats weekly"}
                        </SeriesNote>
                      )}
                      <ProposeInstructorInfo>
                        <ProposeInstructorInfoImg
                          backgroundimage={
                            avatarFor(
                              currentStudent.id
                                ? `${currentStudent.attributes.first_name} ${currentStudent.attributes.last_name || ""}`
                                : "",
                              currentStudent.id ? currentStudent.attributes.avatar_url : ""
                            )
                          }
                        >
                          <img
                            src={
                              avatarFor(
                                currentStudent.id
                                  ? `${currentStudent.attributes.first_name} ${currentStudent.attributes.last_name || ""}`
                                  : "",
                                currentStudent.id ? currentStudent.attributes.avatar_url : ""
                              )
                            }
                            alt=""
                            style={{
                              width: 60,
                              height: 60,
                              borderRadius: "50%",
                              marginRight: 16,
                              display: "none",
                            }}
                          />
                        </ProposeInstructorInfoImg>

                        <ProposeInstructorNameBox>
                          <ProposeUserRole>Student</ProposeUserRole>
                          <ProposeInstructorName
                            onClick={(event) => {
                              onOpenStudentListPopper(event);
                            }}
                            aria-describedby={"student-list-popover"}
                          >
                            {currentStudent.id
                              ? `${currentStudent.attributes.first_name} ${currentStudent.attributes.last_name || ''}`
                              : "Please select Student"}
                            <ExpandMoreIcon />
                          </ProposeInstructorName>
                          {balance && !(balance.bought === 0 && balance.taken === 0 && balance.booked === 0) && (
                            <BalanceLine data-tone={balanceTone(balance)} data-testid="lesson-balance">
                              <span className="dot" aria-hidden="true" />
                              {balance.bought > 0 ? (
                                <>
                                  <span>{lessonCount(balance.left)} left</span>
                                  <span className="muted">·</span>
                                  <span>{lessonCount(balance.booked)} booked</span>
                                  {/* Past zero there is no future run-out, only how
                                      long they have been on trust. */}
                                  {balance.runs_out_on && (
                                    <>
                                      <span className="muted">·</span>
                                      <span>runs out {shortDate(balance.runs_out_on)}</span>
                                    </>
                                  )}
                                  {balance.ran_out_on && (
                                    <>
                                      <span className="muted">·</span>
                                      <span>ran out {shortDate(balance.ran_out_on)}</span>
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  <span className="muted">No package on file</span>
                                  <span className="muted">·</span>
                                  <span>{lessonCount(balance.taken)} taken</span>
                                  <span className="muted">·</span>
                                  <span>{lessonCount(balance.booked)} booked</span>
                                </>
                              )}
                            </BalanceLine>
                          )}
                        </ProposeInstructorNameBox>
                      </ProposeInstructorInfo>
                      <ProposeInstructorInfo>
                        <ProposeInstructorInfoImg
                          backgroundimage={
                            avatarFor(
                              currentInstructor.id
                                ? `${currentInstructor.attributes.first_name} ${currentInstructor.attributes.last_name || ""}`
                                : "",
                              currentInstructor.id ? currentInstructor.attributes.avatar_url : ""
                            )
                          }
                        >
                          <img
                            src={
                              avatarFor(
                                currentInstructor.id
                                  ? `${currentInstructor.attributes.first_name} ${currentInstructor.attributes.last_name || ""}`
                                  : "",
                                currentInstructor.id ? currentInstructor.attributes.avatar_url : ""
                              )
                            }
                            alt=""
                            style={{
                              width: 60,
                              height: 60,
                              borderRadius: "50%",
                              marginRight: 16,
                              display: "none",
                            }}
                          />
                        </ProposeInstructorInfoImg>

                        <ProposeInstructorNameBox>
                          <ProposeUserRole>Instructor</ProposeUserRole>
                          <ProposeInstructorName
                            onClick={(event) => {
                              onOpenInstructorListPopper(event);
                            }}
                            aria-describedby={"instructor-list-popover"}
                          >
                            {currentInstructor.id
                              ? currentInstructor.attributes.first_name
                              : "Please select Instructor"}
                            <ExpandMoreIcon />
                          </ProposeInstructorName>
                        </ProposeInstructorNameBox>
                      </ProposeInstructorInfo>

                      {/* Couples: the picked student's dance partners, one
                          checkbox each, booked into the same slot. Editing
                          who is on an existing lesson is its own job. */}
                      {!isEdit &&
                        Array.isArray(currentStudent?.attributes?.partners) &&
                        currentStudent.attributes.partners.length > 0 && (
                          <Box style={{ margin: "4px 0 8px" }}>
                            {currentStudent.attributes.partners.map((partner) => (
                              <FormControlLabel
                                key={partner.id}
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={partnerIds.includes(partner.id)}
                                    onChange={(e) =>
                                      setPartnerIds((prev) =>
                                        e.target.checked
                                          ? [...prev, partner.id]
                                          : prev.filter((id) => id !== partner.id)
                                      )
                                    }
                                  />
                                }
                                label={`Book as a couple with ${partner.full_name}`}
                              />
                            ))}
                          </Box>
                        )}

                      {/* Coaching: a second instructor on the slot — shows on
                          both calendars and counts as two lessons. */}
                      {!isEdit && instructors.length > 1 && (
                        <FormControl fullWidth style={{ margin: "4px 0 8px" }}>
                          <InputLabel id="coach-select-label">
                            Coaching instructor (optional)
                          </InputLabel>
                          <Select
                            labelId="coach-select-label"
                            value={coachId}
                            onChange={(e) => setCoachId(e.target.value)}
                          >
                            <MenuItem value="">None</MenuItem>
                            {instructors
                              .filter((ins) => ins.id !== currentInstructor.id)
                              .map((ins) => (
                                <MenuItem key={`coach-${ins.id}`} value={ins.id}>
                                  {ins.attributes.first_name} {ins.attributes.last_name || ""}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      )}

                      {(hasPlaces || hasCategories) && !moreOpen && (
                        <MoreLine data-testid="more-line">
                          {hasPlaces && <span>{placeName}</span>}
                          {hasPlaces && hasCategories && chosenCategory && <span className="label" aria-hidden="true">·</span>}
                          {hasCategories && chosenCategory && (
                            <span>
                              <span className="dot" aria-hidden="true" style={{ background: chosenCategory.color }} />
                              {chosenCategory.name}
                            </span>
                          )}
                          <button type="button" data-testid="more-change" onClick={() => setMoreOpen(true)}>
                            Change
                          </button>
                        </MoreLine>
                      )}

                      {moreOpen && hasPlaces && (
                        <FormControl
                          fullWidth
                          style={{
                            margin: "8px 0",
                          }}
                        >
                          <InputLabel
                            id="address-select-label"
                            shrink
                            style={{
                              fontSize: 14,
                              fontWeight: 600,
                              color: "#4F4F4F",
                            }}
                          >
                            Location
                          </InputLabel>
                          <Select
                            labelId="address-select-label"
                            value={addressId}
                            onChange={onSelectAddress}
                          >
                            {Array.isArray(addresses) &&
                              addresses.length > 0 &&
                              addresses.map((address) => {
                                const { id, attributes } = address;
                                const { street, city, country } = attributes;
                                return (
                                  <MenuItem value={id} key={`address-${id}`}>
                                    {`${studioName} - ${street}, ${city}, ${country}`}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                        </FormControl>
                      )}

                      {moreOpen && hasCategories && (
                        <FormControl fullWidth style={{ margin: "8px 0" }}>
                          <InputLabel
                            id="category-select-label"
                            shrink
                            style={{
                              fontSize: 14,
                              fontWeight: 600,
                              color: "#4F4F4F",
                            }}
                          >
                            Category
                          </InputLabel>
                          <Select
                            labelId="category-select-label"
                            value={chosenCategoryId || ""}
                            onChange={(event) => {
                              setTouched(true);
                              setCategoryId(event.target.value);
                            }}
                          >
                            {offeredCategories.map((c) => (
                              <MenuItem value={c.id} key={`category-${c.id}`}>
                                <span aria-hidden="true" style={{ display: "inline-block", width: 8, height: 8, borderRadius: "50%", background: c.color, marginRight: 8 }} />
                                {c.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}

                      <FormControl
                        fullWidth
                        style={{
                          margin: "8px 0",
                        }}
                      >
                        {proposalTimesOut.length !== 1 && <OptionLabel style={{ marginBottom: 10 }}>When</OptionLabel>}
                        <ProposalTimesBox>
                          {proposalTimesOut.map((proposalTime) => (
                            <ProposalTime
                              key={`proposal-time-${proposalTime.id}`}
                            >
                              {/* One time is picked at the top; several proposed times each get their own picker here. */}
                              {proposalTimesOut.length !== 1 && (
                              <Box style={{ width: "100%", marginBottom: 8 }}>
                                <TimeSlotPicker
                                  value={proposalTime.date_time}
                                  onChange={(next) =>
                                    onChangeProposalDateTime(
                                      next,
                                      proposalTime.id
                                    )
                                  }
                                  lessonMinutes={lessonMinutes}
                                  dayStartMinutes={dayStartMinutes}
                                  durationUnits={unitsForSubmit()}
                                  busyRanges={busyRanges}
                                />
                              </Box>
                              )}
                              <OptionSection>
                                <OptionLabel>How long</OptionLabel>
                                <LengthGroup role="group" aria-label="Lesson length">
                                  {lengthOptions.map((opt) => {
                                    const active = proposalTime.options.includes(opt);
                                    const n = parseFloat(opt);
                                    return (
                                      <LengthButton
                                        key={opt}
                                        component="button"
                                        type="button"
                                        data-active={active}
                                        aria-pressed={active}
                                        aria-label={`proposal-time-option-${opt}`}
                                        title={`${durationLabel(n, lessonMinutes)}, counts as ${lessonsText(n)}`}
                                        onClick={() => {
                                          setCurrentProposalTime(proposalTime);
                                          onChangeProposalTimeOption(opt, proposalTime);
                                        }}
                                      >
                                        <span className="len">
                                          {durationLabel(n, lessonMinutes)}
                                        </span>
                                        <span className="cost">
                                          {lessonsText(n)}
                                        </span>
                                      </LengthButton>
                                    );
                                  })}
                                </LengthGroup>

                                {!isEdit && (
                                  <RepeatRow>
                                    <Box style={{ minWidth: 0 }}>
                                      <Typography
                                        style={{ fontSize: 14, fontWeight: 600, color: "#111827" }}
                                      >
                                        Repeat every week
                                      </Typography>
                                      <RepeatNote>
                                        {proposalTime.options.includes(
                                          PROPOSAL_TIME_OPTION_TYPES.RECURRING
                                        )
                                          ? `Books the same slot every week for the next 12 weeks, and keeps going after that. You can move or cancel any one of them.`
                                          : "One lesson, at this time only."}
                                      </RepeatNote>
                                    </Box>
                                    <Switch
                                      color="primary"
                                      checked={proposalTime.options.includes(
                                        PROPOSAL_TIME_OPTION_TYPES.RECURRING
                                      )}
                                      inputProps={{ "aria-label": "proposal-time-option-recurring" }}
                                      onChange={() => {
                                        setCurrentProposalTime(proposalTime);
                                        onChangeProposalTimeOption(
                                          PROPOSAL_TIME_OPTION_TYPES.RECURRING,
                                          proposalTime
                                        );
                                      }}
                                    />
                                  </RepeatRow>
                                )}
                              </OptionSection>
                            </ProposalTime>
                          ))}
                        </ProposalTimesBox>
                      </FormControl>
                      {!isEdit && balance && balance.bought > 0 && (() => {
                        const adding = unitsForSubmit();
                        if (balance.left <= 0) {
                          return (
                            <Typography style={{ fontSize: 12.5, color: "#B45309", marginTop: 6 }}>
                              They have no lessons left on their package. This books on trust.
                            </Typography>
                          );
                        }
                        if (balance.booked + adding > balance.left) {
                          return (
                            <Typography style={{ fontSize: 12.5, color: "#B45309", marginTop: 6 }}>
                              This takes them past their package: {lessonCount(balance.booked + adding)} booked against {lessonCount(balance.left)} left.
                            </Typography>
                          );
                        }
                        return null;
                      })()}

                      {errorMessage && (
                        <FormControl
                          fullWidth
                          style={{
                            margin: "8px 0 15px 0",
                          }}
                        >
                          <Typography style={{ color: "#FF0000" }}>
                            Error: {errorMessage}
                          </Typography>
                          {/* The credits error names an action; hand the owner
                              the door: the sell-a-package button lives on the
                              student's page. Leads never hit the credits gate. */}
                          {/credit/i.test(String(errorMessage)) &&
                            currentStudent.id &&
                            currentStudent.studentType !== "lead" && (
                              <Typography
                                component="a"
                                href={`/users/${currentStudent.id}`}
                                style={{
                                  color: "#007BFF",
                                  marginTop: 6,
                                  textDecoration: "underline",
                                }}
                              >
                                Open {currentStudent.attributes?.first_name ? `${currentStudent.attributes.first_name}'s` : "their"} page to sell a lesson package
                              </Typography>
                            )}
                        </FormControl>
                      )}

                      {datePickerErrorMessage && (
                        <FormControl
                          fullWidth
                          style={{
                            margin: "8px 0 15px 0",
                          }}
                        >
                          <Typography style={{ color: "#FF0000" }}>
                            Error: {datePickerErrorMessage}
                          </Typography>
                        </FormControl>
                      )}

                      <SubmitDock>
                      <FormControl
                        fullWidth
                        style={{ margin: 0 }}
                      >
                        <SubmitProposalTimeButton
                          variant="contained"
                          color="primary"
                          onClick={isEdit ? onSubmitEditLesson : onSubmitCreateLesson}
                        >
                          {!isLoading ? (
                            isEdit ? "Save changes" : "Submit"
                          ) : (
                            <CircularProgress
                              disableShrink
                              style={{ color: "#fff" }}
                            />
                          )}
                        </SubmitProposalTimeButton>
                      </FormControl>
                      </SubmitDock>
                        </>
                      )}
                    </>
                </ProposeModal>
              </Fade>
            </Modal>
          </MuiPickersUtilsProvider>
        )}

        <Dialog open={Boolean(pastPrompt)} onClose={() => setPastPrompt(null)} maxWidth="xs" fullWidth>
          <DialogTitle>Book a lesson on a past day?</DialogTitle>
          <DialogContent>
            {pastPrompt && (() => {
              const days = differenceInCalendarDays(new Date(), pastPrompt.when);
              return (
                <Typography data-testid="past-booking-explainer" style={{ fontSize: 14.5, lineHeight: "21px" }}>
                  {format(pastPrompt.when, "EEE MMM d, h:mm a")} was {days === 1 ? "yesterday" : `${days} days ago`}.
                  It counts as taken as soon as it's saved, and nobody is emailed.
                </Typography>
              );
            })()}
          </DialogContent>
          <DialogActions style={{ padding: "8px 24px 20px", gap: 8 }}>
            <Button onClick={() => setPastPrompt(null)} style={{ textTransform: "none" }}>Change the date</Button>
            <Button
              variant="contained"
              data-testid="confirm-past-booking"
              style={{ textTransform: "none", fontWeight: 600, background: "#1a1a1a", color: "#fff", borderRadius: 20, padding: "6px 18px" }}
              onClick={() => {
                const which = pastPrompt.submit;
                setPastPrompt(null);
                pastConfirmed.current = true;
                (which === "edit" ? onSubmitEditLesson() : onSubmitCreateLesson()).finally(() => {
                  pastConfirmed.current = false;
                });
              }}
            >
              {pastPrompt && pastPrompt.submit === "edit" ? "Move it" : "Book it"}
            </Button>
          </DialogActions>
        </Dialog>

        {cancelOpen && (
          <CancelLessonModal
            isOpen={cancelOpen}
            lesson_id={lesson.id}
            lesson={lesson}
            onClose={() => setCancelOpen(false)}
            onCancelled={({ past }) => {
              setCancelOpen(false);
              onClose();
              const who = (lesson.student_name || "").trim().split(/\s+/)[0];
              const message = past && who ? `Lesson cancelled. ${who} has it back.` : "Lesson cancelled";
              if (onUpdated) {
                showSuccessToast(message);
                onUpdated();
              } else {
                toastAfterReload(message);
                window.location.reload();
              }
            }}
          />
        )}

        {/* Google Calendar's question, asked in the same words people
            already know, and only when there is a tail to move. */}
        <Dialog
          open={scopeDialogOpen}
          onClose={() => setScopeDialogOpen(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>This lesson repeats weekly</DialogTitle>
          <DialogContent>
            <Typography style={{ marginBottom: 8 }}>
              There {followingCount === 1 ? "is" : "are"} {followingCount} more
              after this one. What should change?
            </Typography>
            <Typography style={{ fontSize: 13, color: "#666" }}>
              Earlier lessons in the series never move.
            </Typography>
          </DialogContent>
          <DialogActions style={{ padding: "8px 24px 20px", flexWrap: "wrap", gap: 8 }}>
            <Button onClick={() => setScopeDialogOpen(false)}>Cancel</Button>
            <Button onClick={() => onChooseScope("this")} variant="outlined">
              This lesson only
            </Button>
            <Button
              onClick={() => onChooseScope("following")}
              variant="contained"
              color="primary"
            >
              This and the {followingCount} after it
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={conflictDialog.open}
          onClose={cancelConflictDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>{conflictDialog.overlap ? "Already booked" : "Schedule Conflict Detected"}</DialogTitle>
          <DialogContent>
            {conflictDialog.overlap ? (
              <Box style={{ background: "#FFF8E1", border: "1px solid #FFE082", borderRadius: 8, padding: 12 }}>
                <Typography style={{ fontWeight: 600 }}>{conflictDialog.overlap}</Typography>
              </Box>
            ) : (
            <Typography style={{ marginBottom: 12 }}>
              The proposed time(s) overlap with the following studio class{conflictDialog.conflicts.length > 1 ? "es" : ""}:
            </Typography>
            )}
            {!conflictDialog.overlap && (
            <Box style={{ background: "#FFF8E1", border: "1px solid #FFE082", borderRadius: 8, padding: 12 }}>
              {conflictDialog.conflicts.map((c, idx) => (
                <Box key={`${c.studio_class_id}-${idx}`} style={{ marginBottom: idx === conflictDialog.conflicts.length - 1 ? 0 : 8 }}>
                  <Typography style={{ fontWeight: 600 }}>{c.name}</Typography>
                  <Typography variant="body2" style={{ color: "#666" }}>
                    {c.schedule}
                    {c.instructor_name ? ` · ${c.instructor_name}` : ""}
                    {` · conflict on ${c.reason}`}
                  </Typography>
                </Box>
              ))}
            </Box>
            )}
            <Typography style={{ marginTop: 12, fontSize: 13, color: "#666" }}>
              {conflictDialog.overlap
                ? "Two people on one slot is fine for a showcase routine or a coaching. Book it anyway, or go back and change the time."
                : "You can still create this lesson, just confirming you saw the overlap."}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={cancelConflictDialog}>Cancel</Button>
            <Button onClick={confirmConflictAndCreate} variant="contained" color="primary">
              Book anyway
            </Button>
          </DialogActions>
        </Dialog>

        {isOpenInstructorListPopper && isOpen && instructorListPopperEl && (
          <Popper
            id={"instructor-list-popover"}
            open={isOpenInstructorListPopper && isOpen}
            anchorEl={instructorListPopperEl}
            placement={"bottom-end"}
            transition
            style={{
              zIndex: 1301,
            }}
          >
            {({ TransitionProps }) => (
              <Fade {...TransitionProps} timeout={350}>
                <div>
                  <ClickAwayListener onClickAway={onCloseInstructorListPopper}>
                    <ProposeModalInstructorList>
                      <List component="nav" aria-label="main mailbox folders">
                        {orderedInstructors.map((instructor, index) => (
                          <ListItem
                            button
                            key={`instructor_popper_${instructor.id}`}
                            onClick={() => onClickInstructorPopper(instructor)}
                          >
                            <ListItemText
                              primary={instructor.attributes.first_name}
                              secondary={studentTeacherIds.includes(instructor.id) ? (index === 0 ? "Main teacher" : "Their teacher") : null}
                            />
                          </ListItem>
                        ))}
                      </List>
                    </ProposeModalInstructorList>
                  </ClickAwayListener>
                </div>
              </Fade>
            )}
          </Popper>
        )}

        <StudentPanel
          open={isOpenStudentListPopper && isOpen}
          anchorEl={modalRef.current}
          onClose={onCloseStudentListPopper}
          onPick={onClickStudentPopper}
          students={orderedStudents}
          instructorName={currentInstructor?.attributes?.first_name}
          places={places}
          addresses={addresses}
          categories={categories}
        />

      </ThemeProvider>
    </StylesProvider>
  );
};

export default AddLessonModal;
